import styles from './ProjectGrid.module.css';
import toSentenceCase from '../utilities/sentenceCase.js';
import { useLocation, useParams, useNavigate } from "react-router-dom";

export default function ContentGrid({ title, items }) {

    const { lang } = useParams();

    // setting up an item counter to manage large cells
    let itemCount = 0;

    return (
        <div className={`${styles.project_grid} ${lang === "ko" && styles.lang_ko}`}>

            <div className={`${styles.section_title} preserve-line-breaks`}>
                <h1>{title}</h1>
            </div>

            <div className={styles.grid}>

                {items.map((item, i) => {

                    ++itemCount;
                    let itemSize = item.fields.gridSize === "large" ? styles.large : styles.regular;

                    if (itemCount > 2) {
                        itemCount = 1;
                    }

                    if (item.fields.gridSize === "large") {
                        itemCount = 0;
                    }

                    let itemAlignClass = styles.left;
                    if (itemCount % 2 == 0) {
                        itemAlignClass = styles.right;
                    }

                    return (

                        <div className={`${styles.cell} ${styles.content} ${itemSize} ${itemAlignClass}`} key={i} data-count={itemCount}>
                            <div className={styles.media}>
                                <img
                                    src={`https:${item.fields.media.fields.file.url}`}
                                    alt={item.fields.title}
                                    width={item.fields.media.fields.file.details.image.width}
                                    height={item.fields.media.fields.file.details.image.height}
                                    className="absolute-cover"
                                />

                                <div className={styles.info}>
                                    <h2 className={styles.title}>{item.fields.title}</h2>
                                </div>

                            </div>


                            {item.fields.caption && (
                                <div className={styles.caption}>
                                    <p>{item.fields.caption}</p>
                                </div>)}

                        </div>
            
                    );

                })}

            </div>

        </div>
    )
}